var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasSlot("content")
    ? _c("div", { ref: "filters", attrs: { id: "filters" } }, [
        _c(
          "div",
          {
            staticClass: "filters-content",
            on: {
              click: function ($event) {
                return _vm.toggle()
              },
            },
          },
          [_vm._t("content")],
          2
        ),
        _vm._v(" "),
        _vm.isActive
          ? _c(
              "div",
              {
                ref: "filterDropdown",
                staticClass: "filters-dropdown",
                class: [_vm.align],
              },
              [
                _c("div", { staticClass: "filter-dropdown-head" }, [
                  _c("div", { staticClass: "filter-dropdown-back" }, [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            return _vm.back()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.operators ||
                                _vm.selectedInput ||
                                !_vm.selectable
                                ? "arrow_back_ios"
                                : ""
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [_vm._v("Filters")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "material-icons",
                      staticStyle: {
                        "font-size": "22px",
                        "font-weight": "bold",
                        cursor: "pointer",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggle()
                        },
                      },
                    },
                    [_vm._v("close")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "filter-dropdown-content",
                    style: {
                      transform: _vm.operators
                        ? "translate(-600px)"
                        : _vm.selectedInput
                        ? "translate(-300px)"
                        : "translate(0)",
                    },
                  },
                  [
                    _c("div", { staticClass: "filter-dropdown-first item" }, [
                      _c(
                        "div",
                        { staticClass: "filters-items" },
                        _vm._l(_vm.data, function (item) {
                          return _c("div", { staticClass: "filters-item" }, [
                            _c(
                              "div",
                              {
                                staticClass: "filters-item-name",
                                on: {
                                  click: function ($event) {
                                    return _vm.select(item)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v(_vm._s(item.material_icons)),
                                ]),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-dropdown-second item" }, [
                      _vm.selectedItem &&
                      _vm.selectedItem.inputs[0].type == "select"
                        ? _c(
                            "div",
                            { staticClass: "filters-items" },
                            _vm._l(
                              _vm.selectedItem.inputs[0].data,
                              function (option) {
                                return _c(
                                  "div",
                                  { staticClass: "filters-item" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "filters-item-name",
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectInput(option.key)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(option.value) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-dropdown-third item" }, [
                      _c(
                        "div",
                        { staticClass: "filters-items" },
                        _vm._l(_vm.getOperators(), function (operator) {
                          return _c("div", { staticClass: "filters-item" }, [
                            _c(
                              "div",
                              {
                                staticClass: "filters-item-name",
                                on: {
                                  click: function ($event) {
                                    return _vm.selectOperator(operator)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.OPERATORS_TYPES[operator]) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }